<template>
    <div>

        <!-- MODAL WINDOW -->
        <modal title="Header- und Teaserbild" transition="zoom" cancel-text="Abbrechen" :show-ok="true" ok-text="Speichern" :backdrop-closable="false" :is-show="showModal" @close="showModal=false" :on-ok="saveImages">

            <div class="is-clearfix croppedImages">

                <!-- for header images -->
                <image-cropper v-model="croppedImage1"
                    :width="349.934123847"
                    :height="175"
                    :quality="4"
                    :prevent-white-space="true"
                    :disable-drag-and-drop="true"
                    :disable-click-to-choose="true"
                    :show-remove-button="false"
                    class="is-pulled-left">

                    <img crossOrigin="anonymous" :src="ogImage" slot="initial" />

                </image-cropper>

                <!-- for teaser images -->
                <image-cropper v-model="croppedImage2"
                    :width="194.401095576"
                    :height="175"
                    :quality="4"
                    :prevent-white-space="true"
                    :disable-drag-and-drop="true"
                    :disable-click-to-choose="true"
                    :show-remove-button="false"
                    class="is-pulled-right">

                    <img crossOrigin="anonymous" :src="ogImage" slot="initial" />

                </image-cropper>

            </div>

        </modal>


        <vue-dropzone
            ref="vueDropzoneOnlineCatalog"
            :url="'fileProcessing/upload?preset='+uploadPreset"
            :maxFiles="1"
            acceptedFiles=".jpg,.jpeg,.png"
            :isClickable="true"
            :dictDefaultMessage = "`<i class='fa fa-cloud-upload'></i>` + $t('CATALOG_PAGE-PREVIEW_UPLOAD')"
            v-on:vdropzone-mounted="dzInit"
            v-on:vdropzone-drop="dzDrop"
            v-on:vdropzone-success="dzSuccess"
            v-on:vdropzone-removed-file="dzRemoveFile"
            dzClass="dzSingle">
        </vue-dropzone>

    </div>

</template>


<script>
import Croppa from 'vue-croppa';
//import 'vue-croppa/dist/vue-croppa.css';
import vue2Dropzone from './dropzoneWrapper';


export default {

    components: {
        vueDropzone: vue2Dropzone,
        'image-cropper': Croppa.component
    },

    props: {
        modalTitle: {
            type: String,
            default: 'Teaser Bild'
        },
        uploadPreset: {
            type: String,
            default: 'catalogPage_onlineCatalog'
        },
        page: {
            type: Object,
            default: {}
        }
    },

    data () {

        return {
            showModal: false,
            ogImage: null,
            croppedImage1: {},
            croppedImage2: {}
        }

    },


    mounted() {

    },

    created() {


    },

    methods: {


        saveImages() {

            if (!this.croppedImage1.hasImage() || !this.croppedImage2.hasImage()) {
                alert('no image to upload')
                return;
            }

            var self = this;

            this.croppedImage1.generateBlob((blob) => {

                var formData = new FormData()
                formData.append('blob', blob, self.page.onlineCatalogImage.filename);

                self.axios.post(self.$config.api + 'fileProcessing/upload?preset='+self.uploadPreset, formData)
  				        .then(function(response) {

                    self.page.onlineCatalogHeader = {
                      filename: response.data.fileName,
  				            path: response.data.dir,
  		                uploadFilename: self.page.onlineCatalogImage.filename
                    }

          				}).catch(function(error) {
          					console.log('Error: ', error.message);
          					self.isSaving = false;
          				});
            }, 'image/jpeg', 0.8);

            this.croppedImage2.generateBlob((blob) => {

                var formData = new FormData()
                formData.append('blob', blob, self.page.onlineCatalogImage.filename);

                self.axios.post(self.$config.api + 'fileProcessing/upload?preset='+self.uploadPreset, formData)
  				        .then(function(response) {

                    self.page.onlineCatalogTeaser = {
                      filename: response.data.fileName,
                      path: response.data.dir,
                      uploadFilename: self.page.onlineCatalogImage.filename
                    }

          				}).catch(function(error) {
          					console.log('Error: ', error.message);
          					self.isSaving = false;
          				});

            }, 'image/jpeg', 0.8);


            // todo: make a promise/response ...
            setTimeout(function() {

                self.$emit('update:pages', self.pages)
                self.$emit('save', { isSilent: false });

            }, 1200);

        },


		dzInit() {

      if(this.page.onlineCatalogImage != null) {

          let url = this.$config.assets + this.page.onlineCatalogImage.path + '/' + this.page.onlineCatalogImage.filename;
          // let mockFile = { id: 'onlineCatalogImage', name: this.page.onlineCatalogImage.filename }
          let mockFile = { id: 'onlineCatalogImage', name: this.page.onlineCatalogImage.filename , type: "image/*", size: 123 };

          // add mockFile to our dropzone
          this.$refs.vueDropzoneOnlineCatalog.$children[0].manuallyAddFile(mockFile, url);

      }

		},


    dzSuccess(file) {

    	var result = JSON.parse(file.xhr.response);

        this.page.onlineCatalogImage = {
          filename: result.fileName,
      		path: result.dir,
      		uploadFilename: file.name
        }

        this.ogImage = this.$config.assets + result.dir + '/' + result.fileName;
        this.showModal = true;

    },

    dzRemoveFile() {

        // return;
        this.page.onlineCatalogImage = null;
        this.page.onlineCatalogHeader = null;
        this.page.onlineCatalogTeaser = null;

        // this.pages[1].onlineCatalogImage = null;
        // this.pages[1].onlineCatalogHeader = null;
        // this.pages[1].onlineCatalogTeaser = null;

        this.$emit('update:page', this.page)
        this.$emit('save', {isSilent: false});

    }
    }
}

</script>


<style>
    .croppedImages .croppa-container {
        border: 1px solid #ccc !important;
    }
    .croppedImages .croppa-container canvas {
        display: block;
    }
</style>
